// Basic - show a collapsable table of invoices
import React, { useState } from 'react'
import styled from 'styled-components'
import { FaFileInvoiceDollar } from 'react-icons/fa'

// Components
import { InvoicesTable } from './InvoicesTable'
import { ControlsButton, S_ControlsButton } from '../ControlsButton'

// Utils
import { formatValueByType } from '../../_helpers/formatting'
import { totalIndicatorStyles } from '../SearchableOverview'

// Styled Componenets
export const S_InvoiceManager = styled.div`
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .left,
  .right {
    display: flex;
    align-items: center;
  }

  .left {
    margin-right: 10px;
  }

  h2,
  h4 {
    margin-right: 15px;
    display: flex;
    align-items: center;
    font-size: 20px;

    svg {
      display: none;
      width: 21px;
      height: 21px;
      margin-right: 8px;
    }
  }

  .count-indicator,
  .total-indicator {
    ${totalIndicatorStyles}
  }

  ${S_ControlsButton} {
    margin-left: 15px;
  }

  .main-expandable-content {
    margin: 10px 0;
  }

  .total-value {
    padding: 20px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
  }

  .document {
    padding: 15px;
    background: #f1f1f1;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background: #d5d5d5;
    }
    svg {
      margin-right: 10px;
    }
  }
`

const getInvoiceTotal = (invoices) => {
  if (!invoices || invoices.length === 0) {
    return 0
  }
  let total = 0
  invoices.forEach((invoice) => {
    total += invoice.invoice_amount
  })
  return total
}

export const InvoiceManager = ({
  // label,
  // valueType = 'currency',
  // inputName = '',
  // initialVal,
  // isEditable = false,
  // isTotal = false,
  // onChange = () => {},
  // onSave = () => {},
  initiallyOpen = false,
  invoices = [],
}) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen)

  const numInvoices = invoices ? invoices.length : 0
  const total = formatValueByType(getInvoiceTotal(invoices), 'currency')

  return (
    <S_InvoiceManager>
      <header>
        <div className="left">
          <h2>
            <FaFileInvoiceDollar />
            Invoices
          </h2>
          <div className="count-indicator">{invoices.length}</div>
        </div>

        <div className="right">
          <div className="total-indicator">{total}</div>
          {numInvoices > 0 && <ControlsButton handleClick={() => setIsOpen(!isOpen)} icon={isOpen ? 'less' : 'more'} />}
        </div>
      </header>

      {numInvoices > 0 && isOpen && (
        <>
          <div className="main-expandable-content">
            <InvoicesTable invoices={invoices} />
          </div>
          <div className="total-value">
            <div>Total Value</div>
            <div>{total}</div>
          </div>
        </>
      )}
    </S_InvoiceManager>
  )
}
